import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Col, Form, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Breadcrumbs, Btn, H4 } from '../../AbstractElements';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import { getClientUrlDataToken } from '../../Utils/restUtils';
import { CustomerPayRep, CustomerPayment, Export, Search, Filter, Account, Customersummary, CustomersummaryReport } from '../../Constant';
import { getAccount, getCustomerSummaryReport, getCustomerSummaryReportRole, getAccountRole } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Transparentspinner from '../Common/Loader/Transparentspinner';
import { useForm } from 'react-hook-form';
import AreaDropdown from '../Common Field/AreaDropdown';


const CustomerSummary = () => {
    const authState = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const [filters, setFilters] = useState({
        searchKey: params.get('search') || '',
    });
    const sortedBy = params.get("sortBy") || '';
    const sortedOrder = params.get("sortOrder") || '';
    const [customerLists, setCustomerList] = useState([]);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const [sortConfig, setSortConfig] = useState({ column: sortedBy, order: sortedOrder });
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: { search: filters.searchKey },
    });

    const CustomerPaymentColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            center: false,
            width: '80px'
        },
        {
            name: <H4>Customer Id</H4>,
            id: 'subscriber_id',
            selector: row =>
                (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                    <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.Customer_id}`}>
                        {row.Sub_id}
                    </Link> : row.Sub_id,
            sortable: true,
            wrap: true,
            center: false,
        },
        {
            name: <H4>Name</H4>,
            id: 'customer_name',
            selector: row => row.Name,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>Address</H4>,
            id: 'address',
            selector: row => row.Address,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>No. of Bin</H4>,
            id: 'stb_count',
            selector: row => row.Stb,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>No. of Subscription</H4>,
            id: 'subscription_count',
            selector: row => row.Sub,
            sortable: true,
            wrap: true
        },
    ];

    useEffect(() => {
        fetchCustomerPayment(1);
    }, []);

    useEffect(() => {
        setValue('search', filters.searchKey);
    }, [setValue, filters.search]);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortedBy === column.id) {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/customer-summary?search=${filters.searchKey}&sortBy=${column.id}&sortOrder=${newOrder}`);
        } else {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/customer-summary?search=${filters.searchKey}&sortBy=${column.id}&sortOrder=${newOrder}`);
        }
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const onSubmit = async (data) => {
        const searchKey = data.search || '';
        const queryParams = new URLSearchParams({
            search: searchKey,
            sortBy: sortConfig.column || '',
            sortOrder: sortConfig.order || '',
        }).toString();
        navigate(`/report/customer-summary?${queryParams}`);
        setFilters({
            searchKey,
        });
        fetchCustomerPayment(currentPage, perPage);
    };

    const fetchCustomerPayment = async (page, size = perPage) => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomerSummaryReport +
            `?page=${page}&page_length=${size}&search=${filters.searchKey}&sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}` :
            getCustomerSummaryReportRole + `?page=${page}&page_length=${size}&search=${filters.searchKey}&sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const valuePackages = response.data.data;
            const SerialNo = (page - 1) * size + 1;
            setCustomerList(Object.keys(valuePackages).map((e, index) => {
                return {
                    Si: SerialNo + index,
                    Name: valuePackages[e].customer_name,
                    Address: valuePackages[e].address,
                    Sub_id: valuePackages[e].subscriber_id,
                    Stb: valuePackages[e].stb_count,
                    Sub: valuePackages[e].subscription_count,
                    Paidat: valuePackages[e].date,
                    txnId: valuePackages[e].transaction_id,
                    Amount: valuePackages[e].amount,
                    RefInvoice: valuePackages[e].invoice_number,
                    payType: valuePackages[e].payment_type,
                    order_id: valuePackages[e].order_id,
                    Customer_id: valuePackages[e].id,
                    Area: valuePackages[e].area_name,
                }
            }
            ))
            setTotalRows(response.data.total);
        } else {
            handleApiError(data.status);
        }
        setLoading(false)
    };

    const exportCollectionExcel = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomerSummaryReport +
            `?export=payment_report&search=${filters?.searchKey ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getCustomerSummaryReportRole + `?export=payment_report&search=${filters?.searchKey ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ customer_name, address, subscriber_id, stb_count, subscription_count }, index) => ({ Sl: index + 1, Name: customer_name, Address: address, Customer_id: subscriber_id, No_of_bins: stb_count, No_of_subscription: subscription_count }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'customer Data');
            XLSX.writeFile(wb, 'customer_report.xlsx');
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportCollectionPdf = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomerSummaryReport +
            `?export=payment_report&search=${filters?.searchKey ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getCustomerSummaryReportRole + `?export=payment_report&search=${filters?.searchKey ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ customer_name, address, subscriber_id, stb_count, subscription_count }, index) => ({ Sl: index + 1, Name: customer_name, Address: address, Subscription_id: subscriber_id, No_of_bins: stb_count, No_of_subscription: subscription_count }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["Sl", "Name", "Address", "Customer id", "No.of Bins", "No.of Subscriptions"];
            const rows = dataToExport.map(({ Sl, Name, Address, Subscription_id, No_of_bins, No_of_subscription }) => [Sl, Name, Address, Subscription_id, No_of_bins, No_of_subscription]);
            doc.autoTable({
                head: [columns],
                body: rows,
                columnStyles: {
                    2: { cellWidth: 40 }
                }
            });
            doc.save("CustomerSummary.pdf");
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchCustomerPayment(page);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCustomerPayment(page, newPerPage);
        setPerPage(newPerPage);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={Customersummary} parent="Reports" title={Customersummary} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{CustomersummaryReport}</H3>
                    <div>
                        {(authState.userRole === 1 || authState.permissions.includes('export-report')) &&
                            <CardBody className="dropdown-basic">
                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                        {Export} <i className="icofont icofont-arrow-up"></i>
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => exportCollectionExcel()} ><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => exportCollectionPdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </CardBody>
                        }
                    </div>
                </CardHeader>

                <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Row className="ps-3 gap-sm-3 gap-md-2 filterGap">
                        <Col sm="12" md='5' lg='2'>
                            <input className="form-control" placeholder={Search} type="text"
                                {...register('search')} />
                        </Col>
                        <Col sm="12" md="5" lg='1' className="custom-filtrs">
                            <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                        </Col>
                    </Row>
                </Form>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={CustomerPaymentColumns}
                            data={customerLists}
                            onSort={handleSort}
                            sortServer
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default CustomerSummary;